export default "__VITE_PUBLIC_ASSET__aab40261__"